import Rollbar from 'rollbar';

export default function (store) {
    window._rollbarConfig = {
        accessToken: '3c75b8820b7f44ef94f0b0289c3594df',
        captureUncaught: true,
        payload: {
            environment: window.location.host,
            client: {
                javascript: {
                    source_map_enabled: true,
                    code_version: process.env.REACT_APP_BUILD_NUMBER || 0,
                    guest_uncaught_frames: true
                }
            }
        },
        transform: payload => {}
    };

    window._version = {
        version: process.env.REACT_APP_BUILD_NUMBER || 0,
        date: process.env.REACT_APP_DATE
    };

    Rollbar.init(window._rollbarConfig);
}



// WEBPACK FOOTER //
// ./src/utils/rollbar.js